import React, { useEffect, useState } from "react";
import { RadarDashboard } from "./components/RadarDashboard";

const APP_BRIDGE_SRC = "https://cdn.shopify.com/shopifycloud/app-bridge/dist/latest/index.js";
const POLARIS_HOME_SRC = "https://cdn.shopify.com/shopifycloud/polaris/latest/dist/app-home-latest.js";

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (existing.getAttribute("data-loaded") === "1") {
        resolve();
        return;
      }
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error(`Failed to load ${src}`)), { once: true });
      return;
    }
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => {
      s.setAttribute("data-loaded", "1");
      resolve();
    };
    s.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(s);
  });
}

export default function ShopifyApp() {
  const urlParams = new URLSearchParams(window.location.search);
  const shopOrigin = urlParams.get("shop");
  const [shopifyReady, setShopifyReady] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    if (!shopOrigin) return undefined;
    let cancelled = false;
    (async () => {
      try {
        await loadScript(APP_BRIDGE_SRC);
        if (cancelled) return;
        await loadScript(POLARIS_HOME_SRC);
        if (!cancelled) setShopifyReady(true);
      } catch (err) {
        if (!cancelled) setLoadError(err?.message || "Script load failed");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [shopOrigin]);

  if (!shopOrigin) {
    return <div>Error: Missing shop parameter</div>;
  }

  if (loadError) {
    return (
      <div style={{ padding: "1.5rem", fontFamily: "system-ui, sans-serif" }}>
        <p>Could not load Shopify embedded UI: {loadError}</p>
        <p style={{ fontSize: "0.875rem", color: "#555" }}>Try again or open this app from the Shopify admin.</p>
      </div>
    );
  }

  if (!shopifyReady) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", fontFamily: "system-ui, sans-serif" }}>
        <p>Loading Shopify…</p>
      </div>
    );
  }

  return <RadarDashboard shop={shopOrigin} />;
}
